<template>
  <div class='sub-page' style='margin:0 auto;'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
          <div class='sub-title-wrap-tab'>
            <ul>
              <li class='float-left sub-title'>{{tab.title}}</li>
            </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='inventory-plan float-left'>
        <dx-data-grid ref='refIventoryPlanGrid'
          :data-source='inventoryPlanInfo'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          @focused-row-changed="onSelectionChanged"
          :auto-navigate-to-focused-row="false"
          key-expr="실사기준일"
          :focused-row-key.sync='focusedRowKey'
          @row-removed='onRowRemoved' @row-removing='onRowRemoving'
          @row-inserted='onRowInserted' @row-inserting='onRowInserting'
          @row-updated='onRowUpdated' @row-updating='onRowUpdating'
          @editor-preparing='onEditorPreparing'
          @init-new-row='onInitNewRow'
          @toolbar-preparing='onToolbarPreparing'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="실사계획"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="true"
            :allow-updating="true"
            :allow-adding="false"
            :use-icons="true"
            mode='row'
          >
          </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            width="80"
            :buttons="editButtons"
            type="buttons"
          />
          <DxColumn
            :allowEditing='isIdEdit'
            caption="실사기준일시"
            data-field="실사기준일"
            :visible='true'
            dataType= 'datetime'
            format='yyyy-MM-dd HH:00'
            width=120
            sort-order='desc'
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="실사완료"
            data-field="완료"
            alignment='center'
            width=70
          >
            <DxLookup
              :data-source="ynLookup"
              display-expr="코드"
              value-expr="코드"
            />
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="내용"
            data-field="내용"
            width=210
          >
          </DxColumn>
          <DxColumn
            :allowEditing='isBaseEdit'
            caption="기초재고"
            data-field="기초재고"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="등록인"
            data-field="createid"
            :visible='true'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="수정인"
            data-field="updateid"
            :visible='true'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="등록일"
            data-field="createtime"
            dataType= 'date'
            format='yyyy-MM-dd'
            :visible='false'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="수정일"
            data-field="updatetime"
            dataType= 'date'
            format='yyyy-MM-dd'
            :visible='false'
          >
          </DxColumn>

          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="실사기준일"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <!-- ***************************************************************************** -->
      <!-- ********************** 실사현황 그리드 ****************************************** -->
      <!-- ***************************************************************************** -->
      <div class='inventory-count float-left'>
        <dx-data-grid ref='refIventoryCountGrid'
          :data-source='inventoryCountInfo'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          :focused-row-key.sync='focusedRowKeyCount'
          @toolbar-preparing='onToolbarPreparingCount'
          @cell-prepared='onCellPreparedCount'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="inventoryTitle"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="false"
            :allow-updating="false"
            :allow-adding="false"
            :use-icons="true"
            mode='row'
          >
          </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn v-if="$store.getters.getGroupName !== null"
            :allowEditing='false'
            :caption="$store.getters.getGroupName"
            data-field="차종"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품명"
            data-field="품명"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구분"
            data-field="구분"
            alignment='center'
            sort-order='asc'
          >
            <DxLookup
              :data-source="inentoryLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="실사수량"
            data-field="실사수량"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="전산재고"
            data-field="현재고"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="차이(실사-전산)"
            data-field="차이"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="재고조정"
            data-field="재고조정"
            alignment='center'
          >
            <DxLookup
              :data-source="ynLookup"
              display-expr="코드"
              value-expr="코드"
            />
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="품번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
          <template #inventory-count>
            <div class="toolbar-label" style='font-size:1.2rem;margin-left:0px;'>
              <b>{{inventoryTitle}}</b>
            </div>
        </template>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
    <DxPopupGen
      :visible.sync="popupHelp"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-title="false"
      :width="390"
      :height="360"
    >
      <div class='popup-help-view'>
        <div class='popup-title'>Hi-SFS<b> 실사관리</b></div>
        <p class='popup-content'>
          <b>1. 기초재고</b> : Hi-SFS 실 업무 적용시 기초재고 등록 옵션이며 단 1회만 기초재고 등록 옵션을 선택할 수 있습니다.
        </p>
        <p class='popup-content'>
          <b>2. 실사기준일</b>: 매월 1일 09시 기준 이월재고가 자동으로 업데이트 되기 때문에 실사 기준일은 1일 기준으로 설정 할 수 없으며
          가능한 <b>월말</b>을 실사 기준으로 설정 하여주세요.
        </p>
        <p class='popup-content'>
          <b>3. 실사기준시간</b>: 모든 전표 및 생산실적 시점 관리를 위해 <b>{{startTime}}</b>기준으로 자동 설정 됩니다.
        </p>
        <p class='popup-content'>
          <b>4. 재고조정</b>
        </p>
         <p class='popup-content-sub'>
          - 기초재고 옵션 설정시는 모든 품목의 창고재고/재공재고는 0으로 Reset후 실사재고로 업데이트 됩니다.
        </p>
        <p class='popup-content-sub'>
          - 기초재고 옵션 미설정시는 실사 품목만 전산 재고 차이만큼 보정되어 이월재고가 업데이트 됩니다.
        </p>
        <div class='ok-button float-right' @click='popupHelp=!popupHelp'>확인</div>
      </div>
    </DxPopupGen>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      selectedIndex: 0,
      userInfo: null,
      tabs: [
        {
          title: '실사관리'
        }
      ],
      inventoryPlanInfo: null,
      gridHeight: null,
      focusedRowKey: null,
      editButtons: ['edit', 'delete'],
      isIdEdit: true,
      ynLookup: null,
      selectedPlan: null,
      popupHelp: false,
      isBaseEdit: false,
      startTime: null,
      // 실사결과
      ckAllItem: false,
      inventoryTitle: '실사현황',
      focusedRowKeyCount: null,
      inventoryCountInfo: null,
      btnInventoryResultSave: null,
      inentoryLookup: [
        {
          코드: 0,
          코드명: '창고재고'
        },
        {
          코드: 1,
          코드명: '재공재고'
        }
      ]

    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxRequiredRule,
    DxPopupGen
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.startTime = this.$_.findWhere(this.$store.getters.getSysParam, { key: '주간생산시작시간' }).value
    this.ynLookup = ConstDef.YN_LOOKUP
    this.refreshInventoryPlan()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onEditorPreparing (e) {
      if (e.dataField === '실사기준일' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
      if (e.dataField === '기초재고' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isBaseEdit = false
          if (this.$_.findIndex(this.inventoryPlanInfo, { 기초실사: true }) < 0) {
            this.isBaseEdit = true
          }
        } else {
          this.isBaseEdit = false
        }
      }
    },
    onInitNewRow (e) {
      let day = AppLib.calcDateFromToday(1)
      if (day.substring(5, 7) === '01') {
        e.data.실사기준일 = `${AppLib.calcDateFromToday(2)} ${this.startTime}`
      } else {
        e.data.실사기준일 = `${day} ${this.startTime}`
      }
      e.data.완료 = 'N'
      if (this.inventoryPlanInfo.length > 0) {
        e.data.기초재고 = false
      } else {
        e.data.기초재고 = true
      }
    },
    onRowInserted (row) {
      this.isLoading = true
      row.data.updatetime = row.data.createtime = AppLib.getNow()
      row.data.updateid = row.data.createid = this.userInfo.userName
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runInsertSqlProc('재고실사계획', null, array)
        .then((data) => {
          this.focusedRowKey = row.data.실사기준일
          this.$snotify.info('저장 되었습니다.')
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowInserting (row) {
      console.log(row)
      let temp = AppLib.formatDateTimeFromTimeStamp(row.data.실사기준일)
      const time = this.$_.findWhere(this.$store.getters.getSysParam, { key: '재고관리기준시간' }).value
      row.data.실사기준일 = `${temp.substring(0, 10)} ${time}`
      if (temp.substring(8, 10) === '01') {
        row.cancel = true
        this.$snotify.info('1일 실사기준일은 설정할 수 없습니다.')
      }
    },
    onRowRemoved (row) {
      this.isLoading = true
      this.$_sp.runDeleteSqlProc('재고실사계획', [{ 실사기준일: row.data.실사기준일 }])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('삭제되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error('해당 실사 계획은 실사 진행 중 중입니다.')
          } else {
            console.log(error)
          }
          this.refreshInventoryPlan()
        })
    },
    onRowRemoving (row) {
      if (row.data.완료 === 'Y') {
        this.$snotify.error('실사 완료된 계획은 삭제할 수 없습니다.')
        row.cancel = true
      }
    },
    onRowUpdated (row) {
      console.log(row)
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userName
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('재고실사계획', ['실사기준일'], null, array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowUpdating (row) {

    },
    refreshInventoryPlan () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindSqlProc('재고실사계획', null)
        .then((data) => {
          this.isLoading = false
          this.inventoryPlanInfo = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedPlan = e.row.data
        this.inventoryTitle = `실사현황(${AppLib.formatDateTimeFromTimeStamp(this.selectedPlan.실사기준일).substring(0, 13)}:00)`
      }
      this.refreshInventoryCount(this.selectedPlan.실사기준일)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>실사계획</b></div>`
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '도움말',
            icon: 'help',
            focusStateEnabled: true,
            onClick: (args) => {
              this.popupHelp = true
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '계획 추가',
            icon: 'add',
            focusStateEnabled: true,
            onClick: (args) => {
              if (this.$_.findIndex(this.inventoryPlanInfo, { 완료: 'N' }) >= 0) {
                this.$snotify.warning('완료되지 않은 실사 계획이 있습니다.')
                return
              }
              this.$refs.refIventoryPlanGrid.instance.addRow()
            }
          }
        }
      )
    },
    // ******************* 실사 내역 ************************************
    // ******************* 실사 내역 ************************************
    // ******************* 실사 내역 ************************************
    onCellPreparedCount (e) {
      if (e.rowType === 'data' && e.column.dataField === '구분') { // 창고재고
        if (e.data.구분 === 1) { // 재공재고
          this.$Q(e.cellElement).css('color', 'red')
        } else {
          this.$Q(e.cellElement).css('color', 'blue')
        }
      }
    },
    onToolbarPreparingCount (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'inventory-count'
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            disabled: true,
            icon: 'save',
            text: '재고조정',
            type: 'danger',
            onInitialized: (args) => {
              this.btnInventoryResultSave = args.component
            },
            onClick: (args) => {
              this.$snotify.confirm('재고 조정 후에는 원복이 불가능 합니다. 재고 조정 하시겠습니까?', '', {
                timeout: 20000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  { text: '재고조정',
                    action: (toast) => {
                      this.$snotify.remove(toast.id)
                      this.updateInventoryCountResult(this.selectedPlan.실사기준일)
                    }
                  },
                  { text: '취소',
                    action: (toast) => { this.$snotify.remove(toast.id) }
                  }
                ]
              })
            }
          }
        }
      )
    },
    refreshInventoryCount (date) {
      console.log(date)
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllInventoryCountByDateV2', { toDate: AppLib.formatDateTimeFromTimeStamp(date), 기초재고: this.selectedPlan.기초재고 })
      // this.$_sp.runNoEncodeFindProc('spFindAllInventoryCountByDate', { 기준일: AppLib.formatDateFromTimeStamp(date) })
        .then((data) => {
          this.inventoryCountInfo = this.$_sp.MakeModel(data)
          this.isLoading = false
          this.btnInventoryResultSave.option({ disabled: this.selectedPlan.완료 === 'Y' })
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    updateInventoryCountResult (date) {
      let sp = 'spUpdateInventoryCountResultByDateV2'
      if (this.selectedPlan.기초재고 === true) {
        sp = 'spUpdateBasicInventoryCountResult'
      }
      this.isLoading = true
      // console.log(this.$_.findWhere(this.$store.getters.getSysParam, { key: '재고관리기준시간' }))
      let temp = {
        toDate: AppLib.formatDateTimeFromTimeStamp(date)
      }
      this.$_sp.runUpdateProc(sp, [temp])
        .then((data) => {
          this.$snotify.info('재고 조정이 완료 되었습니다.')
          this.isLoading = false
          this.selectedPlan.완료 = 'Y'
          this.$refs.refIventoryPlanGrid.instance.refresh()
          this.refreshInventoryCount(this.selectedPlan.실사기준일)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    }

  }
}
</script>

<style lang="scss">
  .inventory-plan {
    width: 40%;
    margin-right:2%;
  }
  .inventory-count {
    width: 58%;
  }

</style>
